import { matchBackgroundColor } from 'modules/BrandDefinition';
import * as Models from 'models';

/**
 * Resets nonexistent brand style and saves applied styles everywhere if it's possible
 */
export const resetBrandStyleOnRelation = (
  textRelationStyles: Models.TextRelationStyles,
  colors: Models.BrandColorsList,
): Models.TextRelationStyles => {
  const { backgroundColor } = textRelationStyles;

  // BACKGROUND COLOR
  const updatedBackgroundColor = matchBackgroundColor(backgroundColor, colors);

  return {
    ...textRelationStyles,
    brandStyleId: null,
    brandStyleChanged: false,
    backgroundColor: updatedBackgroundColor,
  };
};
